module.exports = __webpack_public_path__ + "img/list_Story_14.0ea0be0a.jpeg";